import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import { Box, Button, Typography, InputLabel } from "@mui/material"
import style from "./style";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

// import { useAlert } from "../../../../../context/AlertContext";
import CustomInput from "../../../.././../components/CustomInput";
import { useForm } from "../../../../../hooks/useForm";
import { addInvoice } from "../../../../../constants/data";
import { addInvoiceValidation } from "../../../../../helper/Validation";


const CreateInvoice = () => {

  const [productInformation, setProductInformation] = useState([{}]);


  const handleAddField = () => {
    setProductInformation([...productInformation, {}]);

  };

  const handleDeleteField = (index) => {
    const updatedProductInformation = [...productInformation];
    updatedProductInformation.splice(index, 1);
    setProductInformation(updatedProductInformation);

  };
  // const {showAlert} = useAlert();
  
  // const handleAlert = () =>{
  //   showAlert("Development In Progress","success");
  // }

  // const [item, setItem] = useState();

  const handleCreateInvoice = async () => {
    // handleAddNewInvoice(data);
  }
  const { state, handleChange, handleSubmit, disable, handleFocus,  } = useForm(
    addInvoice,
    addInvoiceValidation,
    handleCreateInvoice,
  );
  const { invNumber, cName, client, project, emailAddress, phone, clientAddress, billingAddress, tax, invoiceDate, dueDate, productName, description, unitCost, qty, amount, discount, optional } = state;

  return (
    <>


      <Box px="15px" mt={2}>
        <Box sx={style.headerContainer}>
          <Typography sx={style.leaveHeading}>Create Invoice</Typography>
        </Box>


      </Box>
      <Box sx={style.itemSection}>
        <Box sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}></Box>
        <Typography sx={style.gridText}>Invoice Details</Typography>
      </Box>

      <form onSubmit={e => handleSubmit(e)}>

        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={11.8} sx={style.gridbox}>
            <Box sx={style.inputSection}>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Invoice Number</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="invNumber"
                  error={invNumber?.error}
                  name="invNumber"
                  value={invNumber?.value}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="invNumber"
                />
              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Company Name</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="cName"
                  error={cName?.error}
                  name="cName"
                  value={cName?.value}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="cName"
                />
              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Client</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="client"
                  error={client?.error}
                  name="client"
                  value={client?.value}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="client"
                />
              </Box>
            </Box>
            <Box sx={style.inputSection}>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Project</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="project"
                  error={project?.error}
                  name="project"
                  value={project?.value}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="project"
                />
              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Email Address</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="emailAddress"
                  error={emailAddress?.error}
                  name="emailAddress"
                  value={emailAddress?.value}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="emailAddress"
                />
              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Phone Number</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="phone"
                  error={phone?.error}
                  name="phone"
                  value={phone?.value}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="phone"
                />
              </Box>
            </Box>
            <Box sx={style.inputSection}>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Client Address</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="clientAddress"
                  error={clientAddress?.error}
                  name="clientAddress"
                  value={clientAddress?.value}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="clientAddress"
                />
              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Billing Address</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="addressLine2"
                  error={billingAddress?.error}
                  name="billingAddress"
                  value={billingAddress?.value}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="billingAddress"
                />
              </Box>
              <Box sx={style.inputBox}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <InputLabel sx={style.label}>Invoice Date</InputLabel>
                  <DatePicker value={dayjs(invoiceDate.value)} maxDate={dayjs().subtract(18, "year")} onChange={(newValue) => { handleChange("dob", newValue) }} sx={style.dateInput}
                    slotProps={{
                      field: {
                        readOnly: true
                      }
                    }} />
                </LocalizationProvider>              </Box>
            </Box>
            <Box sx={style.inputSection}>


              <Box sx={style.inputBox}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <InputLabel sx={style.label}>Due Date</InputLabel>
                  <DatePicker value={dayjs(dueDate.value)} maxDate={dayjs().subtract(18, "year")} onChange={(newValue) => { handleChange("dob", newValue) }} sx={style.dateInput}
                    slotProps={{
                      field: {
                        readOnly: true
                      }
                    }} />
                </LocalizationProvider>
              </Box>
              <Box sx={style.inputBox}>
              </Box>

            </Box>




          </Grid>
          <Box sx={style.itemSection}>
            <Box sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}></Box>
            <Typography sx={style.gridText}>Product Informations</Typography>
          </Box>

          <Grid item xs={12} lg={11.8} sx={style.gridbox}>
            {productInformation.map((item, index) => (

              <Box sx={style.leaveSection} key={index}>
                <Grid container sx={style.itemGrid} >
                  <Grid item xs={1} lg={0.5}>
                    <Typography>{index + 1}</Typography>
                  </Grid>
                  <Grid item xs={4.5} lg={2}>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="productName"
                      placeholder="Product name"
                      error={productName?.error}
                      name="productName"
                      value={productName?.value}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      autoComplete="productName" 
                    />

                  </Grid>
                  <Grid item xs={5.5} lg={3.5}>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="description"
                      placeholder="Description"
                      error={description?.error}
                      name="description"
                      value={description?.value}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      autoComplete="description" 
                    />

                  </Grid>
                  <Grid item xs={5.9} lg={1.5}>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="unitCost"
                      placeholder="Unit Cost"
                      error={unitCost?.error}
                      name="unitCost"
                      value={unitCost?.value}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      autoComplete="unitCost" 
                    />

                  </Grid>
                  <Grid item xs={5.5} lg={1}>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="qty"
                      placeholder="QTY"
                      error={qty?.error}
                      name="qty"
                      value={qty?.value}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      autoComplete="qty" 
                    />

                  </Grid>
                  <Grid item xs={9} lg={1.5}>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="companyName"
                      placeholder="Amount"
                      error={amount?.error}
                      name="amount"
                      value={amount?.value}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      autoComplete="amount" 
                    />

                  </Grid>
                  {(!((productInformation.length - 1) === index)) && (

                    <Grid item xs={1.5} lg={0.5}>
                      <Box sx={style.deleteIcon} onClick={() => handleDeleteField(index)}><DeleteOutlineIcon /></Box>
                    </Grid>
                  )}
                  {((productInformation.length - 1) == index) && (

                    <Grid item xs={1.5} lg={0.5}>
                      <Box sx={style.addIcon} onClick={handleAddField}>+</Box>
                    </Grid>
                  )}
                </Grid>



              </Box>
            ))}

          </Grid>
          <Box sx={style.itemSection}>
            <Box sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}></Box>
            <Typography sx={style.gridText}>Other Informations</Typography>
          </Box>
          <Grid container sx={style.lastGrid}>
            <Grid item xs={12} lg={7.6} sx={style.gridboxs}>
              <Grid container>
                <Grid item xs={12} lg={6}>
                  <Box sx={style.optionalInput}>

                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="Discount"
                      label={"Discount"}
                      placeholder="(Discount)"
                      error={discount?.error}
                      name="discount"
                      value={discount?.value}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      autoComplete="discount"
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} lg={5}>
                  <Box sx={style.optionalInput}>

                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="Tax"
                      label={"Tax"}
                      placeholder="(Tax)"
                      error={tax?.error}
                      name="tax"
                      value={tax?.value}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      autoComplete="tax"
                    />
                  </Box>
                </Grid>
              </Grid>

            </Grid>
            <Grid item xs={12} lg={4.2} >
              <Box sx={{ ...style.itemSection, mt: { lg: -2.5 } }}>
                <Box sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}></Box>
                <Typography sx={style.gridText}>Other Informations</Typography>
              </Box>
              <Grid item xs={12} sx={{ ...style.gridboxs, px: 4 }}>

                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="optional"
                  placeholder="(Optional)"
                  error={optional?.error}
                  name="optional"
                  value={optional?.value}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="companyName"
                />
              </Grid>
            </Grid>
            <Grid item xs={12} lg={4.2} >

            </Grid>

            <Grid item xs={12} lg={4.2} sx={style.gridboxs}>
              <Box sx={style.leaveSection}>
                <Box sx={style.inputContainerBox}>
                  <Box sx={style.key}>
                    <Typography sx={style.descValueText}>Total</Typography>
                  </Box>
                  <Box sx={style.key}>
                    <Typography sx={style.descValueText}>0</Typography>
                  </Box>

                </Box>
                <Box sx={style.inputContainerBox}>
                  <Box sx={style.key}>
                    <Typography sx={style.descValueText}>Tax</Typography>
                  </Box>
                  <Box sx={style.key}>
                    <Typography sx={style.descValueText}>-</Typography>
                  </Box>

                </Box>
                <Box sx={style.inputContainerBox}>
                  <Box sx={style.key}>
                    <Typography sx={style.descValueText}>Discount</Typography>
                  </Box>
                  <Box sx={style.key}>
                    <Typography sx={style.descValueText}>20%</Typography>
                  </Box>

                </Box>
                <Box sx={style.inputContainerBox}>
                  <Box sx={style.key}>
                    <Typography sx={style.descValueTexts}>Grand Total</Typography>
                  </Box>
                  <Box sx={style.key}>
                    <Typography sx={style.descValueTexts}>$340</Typography>
                  </Box>

                </Box>


              </Box>


            </Grid>
          </Grid>



        </Grid>

        <Box sx={style.mainBoxes}>
          <Box sx={style.createJob}>
            <Button variant="contained" color="success" disabled={disable} type="submit" sx={style.cancelButtons}>
              Create Invoice
            </Button>
          </Box>


        </Box>

      </form>


    </>
  )
}
export default CreateInvoice;
